
import axios from "axios";

export const searchByOrderAndAmmount = async (order, ammount, origin) => {
  let url;
  switch(origin){
    case "ML":
      url = new URL(
        `${process.env.REACT_APP_API_URL}/facturas/mercadolibre/consultar`
      );
      break;
    default:
      url = new URL(
        `${process.env.REACT_APP_API_URL}/facturas/coppel/consultar`
      );
  }

  url.searchParams.append("folio", order.trim());
  url.searchParams.append("monto", ammount);
  return axios
    .get(url)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(
        error.response
          ? error.response.data
          : "Hubo un error al cargar la orden"
      );
    });
};

export const requestFactura = async (object) => {
  const {
    folio,
    RFC,
    usoCFDI,
    razonSocial,
    calle,
    colonia,
    numeroExterior,
    numeroInterior,
    codigoPostal,
    idMunicipio,
    idEstado,
    RIF,
    correoCliente,
    monto,
    formaPago,
    origen
  } = object;

  //Determinar URL según el origen
  let url;
  switch (origen) {
    case "ML":
      url = `${process.env.REACT_APP_API_URL}/facturas/mercadolibre`;
      break;
    case "Coppel":
      url = `${process.env.REACT_APP_API_URL}/facturas/coppel`;
      break;
    default:
      throw new Error("Origen no válido");
  }

  return axios
    .post(url, {
      folio: folio,
      RFC,
      usoCFDI,
      razonSocial,
      calle,
      colonia,
      numeroExterior,
      numeroInterior,
      codigoPostal,
      ciudad: idMunicipio,
      estado: idEstado,
      RIF,
      correoCliente,
      monto: Number.parseFloat(monto),
      formaPago
    })
    .then(() => Promise.resolve("Datos enviados correctamente"))
    .catch((error) =>
      Promise.reject(error.response || "Error al enviar los datos")
    );
};


export const requestDefault = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/default`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
      },
    })
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject("Hubo un error al cargar la orden");
    });
};

